import securitySource from '../../content/legal/security.md?raw';
import { LegalLayout } from './LegalLayout';

export default function Security() {
  return <LegalLayout source={securitySource} />;
}
